import { styled } from '@openeducation/oe-it-themes';
import React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';

import { Loading } from '../../atoms/loading/loading';
import { flex } from '../../style-utils';
import PageSectionHeader, {
  PageSectionHeaderProps,
} from '../page-section-header/page-section-header';

export interface PageSectionProps extends PageSectionHeaderProps {
  isLoading?: boolean;
  minHeight?: number;
  headerStyle?: StyleProp<ViewStyle>;
  children?: React.ReactNode;
}

const PageSection: React.FC<PageSectionProps> = ({
  children,
  title,
  subtitle,
  headerRight,
  minHeight,
  isLoading,
  style,
  headerStyle,
}) => {
  const renderContent = () => {
    if (isLoading) {
      return (
        <View
          style={flex('flex-1', 'align-items-center', 'justify-content-center')}
        >
          <Loading size="large" />
        </View>
      );
    }

    return children;
  };

  return (
    <Container minHeight={minHeight} style={style}>
      {(title || subtitle || headerRight || headerStyle) && (
        <PageSectionHeader
          title={title}
          subtitle={subtitle}
          headerRight={headerRight}
          style={headerStyle}
        />
      )}
      {renderContent()}
    </Container>
  );
};

type ContainerType = {
  minHeight?: number;
};

const Container = styled.View<ContainerType>`
  background-color: ${({ theme }) => theme.color.white};
  padding: 40px;
  margin-bottom: 40px;
  border-radius: 14px;
  shadow-radius: 2px;
  shadow-opacity: 0.15;
  shadow-color: ${({ theme }) => theme.color.black};
  shadow-offset: 0 2px;
  min-height: ${({ minHeight }) => (minHeight ? `${minHeight}px` : undefined)};
`;

export default PageSection;
